import React, { useState } from 'react';
import styles from './AddGroup.module.css';
import { generateRandomString } from '../../helper';
import { useDispatch } from 'react-redux';
import { pushGroupRedux } from '../../store/slices/groupsSlice';
import { addGroupBd } from '../../firebase';
import LoaderPage from '../LoaderPage/LoaderPage';
import Checkbox from '../../elemets/Checkbox/Checkbox';

export default function AddGroup() {
  const dispatch = useDispatch();
  const [groupName, setGroupName] = useState('');
  const [groupSortValue, setGroupSortValue] = useState('grop_grops');
  const [loaderPage, setLoaderPage] = useState(false);

  const addCroup = async (groupName, groupSortValue) => {
    if (groupName.length < 3) {
      alert('Назва групи має бути не менше трьох символів.');
      return;
    }
    setLoaderPage(true);
    const itemGroup = {
      groupName,
      sortValue: groupSortValue,
      group_id: generateRandomString(),
      time_milliseconds: new Date().getTime(),
    };
    const ifAddGroup = await addGroupBd(itemGroup);

    if (ifAddGroup) {
      alert('Група додана успішно.');
      dispatch(pushGroupRedux(itemGroup));
      setGroupName('');
    }
    setLoaderPage(false);
  };

  const onChangeGropGrops = () => {
    setGroupSortValue('grop_grops');
  };
  const onChangeGropIndividual = () => {
    setGroupSortValue('grop_individual');
  };
  const onChangeGropFree = () => {
    setGroupSortValue('grop_free');
  };

  const onChangeGropDraft = () => {
    setGroupSortValue('grop_draft');
  };
  const onChangeGropTest = async () => {
    setGroupSortValue('grop_test');
  };

  return (
    <>
      <div className={styles.block_title + ' ' + 'mt_30'}>Створити групу</div>
      <div className={styles.addGroup_wrapper}>
        <div>Називаєм "Я СТРУНКА (1.01.2025-23.01.2025)"</div>
        <input
          className={styles.addGroup_input}
          type="text"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
        />

        <div className={'mb_20'}>
          <div className={'df aic gap_10 mb_15'}>
            <Checkbox
              ifSelected={groupSortValue === 'grop_grops'}
              handleClick={onChangeGropGrops}
            />
            Груповий супровід
          </div>
          <div className={'df aic gap_10 mb_15'}>
            <Checkbox
              ifSelected={groupSortValue === 'grop_individual'}
              handleClick={onChangeGropIndividual}
            />
            Індивідуальний супровід
          </div>
          <div className={'df aic gap_10 mb_15'}>
            <Checkbox ifSelected={groupSortValue === 'grop_free'} handleClick={onChangeGropFree} />
            Безкоштовной супровід
          </div>
          <div className={'df aic gap_10 mb_15'}>
            <Checkbox
              ifSelected={groupSortValue === 'grop_draft'}
              handleClick={onChangeGropDraft}
            />
            Чорновик
          </div>
          <div className={'df aic gap_10 '}>
            <Checkbox ifSelected={groupSortValue === 'grop_test'} handleClick={onChangeGropTest} />
            Для тестування
          </div>
        </div>
        <button className={styles.addGroup_btn} onClick={() => addCroup(groupName, groupSortValue)}>
          Створити
        </button>
      </div>
      {loaderPage && <LoaderPage />}
    </>
  );
}
